<template>
  <div>
    <h1>{{ $t("global.reports") }}</h1>
    <booking-menu />

    <booking-report-extended-filters
      v-if="extendedFilters"
      :selected-columns.sync="selectedColumns"
      :available-columns="availableColumns"
      :show-all.sync="showAll"
      :filters.sync="filtersObject"
      downloadable
      @download="download"
    />

    <booking-report-base-filters
      :selected-columns.sync="selectedColumns"
      :available-columns="availableColumns"
      :from-date.sync="filtersObject.fromDate"
      :to-date.sync="filtersObject.toDate"
      :selected-types.sync="filtersObject.selectedTypes"
      :show-all.sync="showAll"
      downloadable
      @download="download"
      v-if="basicFilters"
    />

    <booking-report-download-component :options="pagination" :dialog.sync="downloadDialog" :type="type" :columns="selectedColumns" :filters="filtersObject" />

    <v-data-table :items="resp" :headers="headers" :options.sync="pagination" :loading="$store.getters['Ajax/loading']" must-sort>
      <template #item="props">
        <!-- eslint-disable-next-line -->
        <tr>
          <td v-for="column of selectedColumns" :key="column">
            <template v-if="column === 'name'">
              <h3>
                {{ props.item.name }} <span v-if="props.item.currency === ''">{{ $t("global.noInvoiceYet") }}</span>
              </h3>
            </template>
            <booking-report-standard-header-column-component :column="column" :currency-content="props.item" />
          </td>

          <td style="text-align: right">
            <v-btn icon @click="showItem(props.item.name)">
              <v-icon v-if="!showItems.includes(props.item.name)">keyboard_arrow_down</v-icon> <v-icon v-else>keyboard_arrow_up</v-icon>
            </v-btn>
          </td>
        </tr>
        <!-- eslint-disable-next-line -->
        <tr v-if="showItems.includes(props.item.name)" v-for="bookingItem of props.item.items" :key="bookingItem.id">
          <td v-for="column of selectedColumns" :key="column">
            <booking-report-currency-item-component
              :booking-item="bookingItem"
              :column="column"
              :currency="props.item.currency"
              :selected-columns="selectedColumns"
            />
          </td>
          <td />
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import BookingMenu from "../../../components/Booking/BookingMenu";
import formatDateView from "../../../repository/fotmatDateView";
import moment from "moment";
import dayOfWeek from "../../../repository/shortDayOfWeekFromDate";
import BookingReportCurrencyItemComponent from "./BookingReportDetailedItemComponent";
import BookingReportStandardHeaderColumnComponent from "../../../components/Booking/Report/BookingReportStandardHeaderColumnComponent";
import BookingReportExtendedFilters from "../../../components/Booking/Report/BookingReportExtendedFilters";
import _ from "lodash";
import BookingReportDownloadComponent from "../../../components/Booking/Report/BookingReportDownloadComponent";
import BookingReportBaseFilters from "./BookingReportBaseFilters";

export default {
  name: "BookingReportBaseComponent",
  components: {
    BookingReportBaseFilters,
    BookingReportDownloadComponent,
    BookingReportExtendedFilters,
    BookingReportStandardHeaderColumnComponent,
    BookingReportCurrencyItemComponent,
    BookingMenu
  },
  props: {
    basicFilters: {
      required: false,
      default: false
    },
    extendedFilters: {
      required: false,
      default: false
    },
    type: {
      required: true,
      type: String
    },
    availableColumns: {
      required: true
    }
  },
  data: () => ({
    resp: [],
    selectedColumns: ["name", "creation_date", "passengers", "count", "grossSummary", "grossSummaryWithDiscount"],
    showItems: [],
    showAll: false,
    pagination: null,
    filtersObject: {
      fromDate: null,
      toDate: null,
      selectedTypes: [],
      organizationUnit: [],
      passengers: [],
      isDomestic: null,
      grossAbove: null,
      grossUnder: null,
      reservationNumbers: [],
      countAbove: null,
      countUnder: null,
      grossSumAbove: null,
      grossSumUnder: null,
      grossAverageAbove: null,
      grossAverageUnder: null,
      fromSaleDate: null,
      toSaleDate: null,
      fromIssueDate: null,
      toIssueDate: null
    },
    cancelToken: null,
    source: null,
    downloadDialog: false
  }),
  watch: {
    showAll(val) {
      if (val) {
        this.pagination.rowsPerPage = -1;
        for (let group of this.resp) {
          if (!this.showItems.includes(group.name)) {
            this.showItems.push(group.name);
          }
        }
      } else {
        this.showItems = [];
      }
    },
    filtersObject: {
      handler() {
        this.source.cancel("Filters changed");
        this.downloadData();
      },
      deep: true
    }
    // "pagination.descending"() {
    //   this.source.cancel("Filters changed");
    //   this.downloadData();
    // },
    // "pagination.sortBy"() {
    //   this.source.cancel("Filters changed");
    //   this.downloadData();
    // }
  },
  methods: {
    download() {
      this.downloadDialog = true;
    },
    dayOfWeek,
    localMoment: moment,
    downloadData: _.debounce(
      function() {
        this.cancelToken = this.axios.CancelToken;
        this.source = this.cancelToken.source();
        this.axios
          .get("booking/report/get-report", {
            params: {
              type: this.type,
              filters: this.filtersObject,
              pagination: this.pagination
            },
            cancelToken: this.source.token
          })
          .then(resp => {
            this.resp = resp.data;
          })
          .catch(() => {});
      },
      1000,
      { leading: true }
    ),
    formatDateView: formatDateView,
    showItem(group) {
      if (this.showItems.includes(group)) {
        this.showItems.splice(this.showItems.indexOf(group), 1);
      } else {
        this.showItems.push(group);
      }
    }
  },
  created() {
    this.cancelToken = this.axios.CancelToken;
    this.source = this.cancelToken.source();
    this.downloadData();
  },
  computed: {
    headers() {
      let headers = [];
      for (let selectedColumn of this.selectedColumns) {
        headers.push(this.availableColumns.find(v => v.selectValue === selectedColumn));
      }
      headers.push({ text: "", value: "actions", sortable: false });
      return headers;
    }
  }
};
</script>

<style scoped>
.datatable-total-amount {
  white-space: nowrap;
  color: #44d3af !important;
  font-weight: bold !important;
}

.datatable-net-amount {
  white-space: nowrap;
  color: #1f16d3 !important;
  font-weight: bold !important;
}

.chip--small {
  height: 22px;
}

.flight-direction {
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
}

.grey--text {
  color: #9e9e9e !important;
}

.bigger {
  margin-right: 4px;
  font-size: 15px;
}

.flight-airport {
  font-weight: 700;
  line-height: 1;
}

.flight-part {
  min-width: 175px;
}
</style>
